import { useState } from 'react';
import { useLocation } from 'react-router-dom';
// Redux
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
// Components
import NavigationBarModules from '../NavigationBarModules';
import Language from '../Language/';
// Images
import logoOnlineLibrary from '../../Images/logo/logo_OlibBlack.svg';
// Icons
import { GiHamburgerMenu } from 'react-icons/gi';
import { MdKeyboardArrowLeft } from 'react-icons/md';
// Services
import {
	getCosmetologySections,
	getSectionsInstitutions,
	getSectionsNoAuth,
	getSectionsWithoutNavbar,
} from '../../services/getSectionsInstitutions';
// Styles
import './NavigationBarResources.css';
import { useAuth } from '../../hooks/useAuth';
import { isCosmetology } from '../../utils/isCosmetology';
import useViewport from '../../hooks/useViewPort';
// Translate
import { useTranslation } from 'react-i18next';

const NavigationBarResources = () => {
	const { t } = useTranslation();
	const { isAuth } = useAuth();
	const { width } = useViewport();
	const { institutionCode, ebooksAccess, institutionLogo } = 
	useSelector(
		(state) => state.institution
	);
	const isCosmetologyInstitution = isCosmetology(institutionCode);

	const { pathname } = useLocation();
	const currentlyRoute = pathname.replace('/', '');
	const mainSections = getSectionsInstitutions(institutionCode, ebooksAccess)[0]
		.data;
	const sectionsMetasearcher = isCosmetology(institutionCode)
		? getCosmetologySections(mainSections)
		: mainSections;

	const independentSectionList = getSectionsInstitutions(
		institutionCode,
		ebooksAccess
	)[1].data.filter((objeto) => objeto.type === 'independient');

	const sectionsIndependientList = isCosmetology(institutionCode)
		? getCosmetologySections(independentSectionList)
		: independentSectionList;

	const independentSections = isAuth()
		? sectionsIndependientList
		: getSectionsNoAuth(sectionsIndependientList);

	const oneSearchTitles = [
		'Articles',
		'Dictionary',
		'Thesaurus',
		'Patents',
		'News',
		'Media',
		'EBooks',
		'Digital Books',
		'Spanish Resources',
	];
	const subjectResourcesTitles = [
		'GALE Resources',
		'Aquino AI',
		'Interesting Resources',
	];
	const otherResourcesTitles = [
		'Art',
		'Job Hunter',
		'Career Development',
		...(width < 1024 ? ['Tutorials'] : []),
		'Help',
	];

	const oneSearchSections = sectionsMetasearcher.filter((section) =>
		oneSearchTitles.includes(section.title)
	);
	const subjectResourcesSections = [
		...sectionsMetasearcher.filter((section) =>
			subjectResourcesTitles.includes(section.title)
		),
		...independentSections.filter((section) =>
			subjectResourcesTitles.includes(section.title)
		),
	];
	const otherResourcesSections = independentSections.filter((section) =>
		otherResourcesTitles.includes(section.title)
	);

	// Get sections without nabvar in the view
	const sectionsWithoutNavbar = getSectionsWithoutNavbar();

	const pageList = [
		'articles',
		'books',
		'art',
		'news',
		'patents',
		'dictionary',
		'thesaurus',
		'media',
		'jobs',
		'interesting-links',
		'american-life',
		'video-library',
		'tutorials',
		'my-favorites',
		'favorites',
		'help',
	];

	const [activeBar, setActiveBar] = useState(false);

	if (pageList.includes(currentlyRoute)) {
		return (
			<>
				<div
					onClick={() => setActiveBar(true)}
					className='optionsNavigationBarContainer'
				>
					<button className='optionsNavigationBar'>
						<GiHamburgerMenu />
					</button>
				</div>

				<section
					className={
						activeBar
							? 'navigationBarResources activeBar'
							: 'navigationBarResources'
					}
				>
					<div
						onClick={() => setActiveBar(false)}
						className={
							activeBar
								? 'navigationBarBackground activeBar'
								: 'navigationBarBackground'
						}
					></div>

					<div className='navigationBarResourcesContainer'>
						{!isCosmetologyInstitution && (
							<div className='containerLogo'>

								{institutionCode !== 'FGU' ? 
									<Link to='/' onClick={() => setActiveBar(false)}>
										<img src={logoOnlineLibrary} alt='logo online library' />
									</Link>
									: 
									<Link to='/' onClick={() => setActiveBar(false)}>
										<img className='logoInstitutionBlack' src={institutionLogo} alt='logo online library' />
									</Link>
							}

								<button onClick={() => setActiveBar(false)}>
									<MdKeyboardArrowLeft className='containerLogoClose' />
								</button>
							</div>
						)}

						{isCosmetologyInstitution && (
							<div className='containerLogo '>
								<Link to='/' className='containerLogoCosmetology' onClick={() => setActiveBar(false)}>
									<img src={logoOnlineLibrary} alt='logo online library' />
									<img src={institutionLogo} alt='logo online library' />
								</Link>
								<button onClick={() => setActiveBar(false)}>
									<MdKeyboardArrowLeft className='containerLogoClose' />
								</button>
							</div>
						)}
						<div className='containerPanel'>
							
							<div className='panelSections'>
								<div className='panelSectionsAndLang'>
									<div className='containerPanelTitle'>
										<p>
											<b>
												{t('One Search')}
											</b>
										</p>
									</div>
									<div className='languageContainerMobile'><Language /></div>
									
								</div>
								{oneSearchSections?.map((section, i) => {
									return (
										<NavigationBarModules
											key={`${section.title}-${i}`}
											type={section.type}
											active={currentlyRoute === section.route}
											resource={section}
											metasearcher={section.type === 'metasearcher'}
											setActiveBar={setActiveBar}
											target={section.target}
										/>
									);
								})}
							</div>
							<div className='panelSections'>
								<div>
									<p>
										<b>
											{t('Subject Resources & Databases')}
										</b>
									</p>
								</div>
								{subjectResourcesSections?.map((section, i) => {
									return (
										<NavigationBarModules
											key={`${section.title}-${section.route}-${i}-subject`}
											type={section.type}
											active={
												currentlyRoute === section.route ||
												currentlyRoute === section.childPage
											}
											resource={section}
											metasearcher={section.type === 'metasearcher'}
											setActiveBar={setActiveBar}
										/>
									);
								})}
							</div>
							<div className='panelSections'>
								<div>
									<p>
										<b>
											{t('Other Resources')}
										</b>
									</p>
								</div>
								{otherResourcesSections?.map((section, i) => {
									return (
										<NavigationBarModules
											key={`${section.title}-${section.route}-${i}-other`}
											type={section.type}
											active={
												currentlyRoute === section.route ||
												currentlyRoute === section.childPage // Permite que se muestre activo con paginas hijas como Favoritos > Detalle de favorito
											}
											resource={section}
											metasearcher={false}
											setActiveBar={setActiveBar}
										/>
									);
								})}
							</div>
						</div>
					</div>
				</section>
			</>
		);
	} else if (sectionsWithoutNavbar.includes(currentlyRoute)) {
		return null;
	} else {
		return <div className='optionsNavigationBarContainer'></div>;
	}
};

export default NavigationBarResources;
